import { create } from 'zustand';

interface ToastItem {
    id: string;
    type: 'success' | 'error';
    message: string;
}

interface ToastState {
    toasts: ToastItem[];
    showToast: (type: 'success' | 'error', message: string) => void;
    dismissToast: (id: string) => void;
}

const MAX_TOASTS = 4;

export const useToastStore = create<ToastState>((set) => ({
    toasts: [],
    showToast: (type, message) =>
        set((state) => {
            const trimmed = state.toasts.length >= MAX_TOASTS ? state.toasts.slice(1) : state.toasts;
            return { toasts: [...trimmed, { id: crypto.randomUUID(), type, message }] };
        }),
    dismissToast: (id) =>
        set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) })),
}));
